import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as DocumentIconSvg } from '../../assets/document-icon.svg';

export const DocumentIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={DocumentIconSvg} {...props} />;
};
